import { useEffect } from 'react';

import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';

import { useDashboardRoute } from 'hooks/useDashboardRoute';

import fetchLogin from 'pages/LoginPage/fetchLogin';
import 'pages/LoginPage/LoginPage.less';

import Spinner from 'components/Spinner';

const LoginPage = () => {
    const dashboardRoute = useDashboardRoute();

    useEffect(() => {
        fetchLogin(dashboardRoute);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ColumnsWrapper>
            <ColumnsRow>
                <Column xs="4" s="8" m="12" l="16">
                    <div className="login-page">
                        <Spinner />
                    </div>
                </Column>
            </ColumnsRow>
        </ColumnsWrapper>
    );
};

export default LoginPage;
